import styled from 'styled-components';
const Wrapper = styled.header.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1eggil0-0"
})(["width:100%;display:flex;min-height:80px;background-color:#ffffff;border-top:4px solid ", ";"], ({
  theme
}) => theme.colors.brand);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-1eggil0-1"
})(["max-width:1320px;width:90%;margin:auto;display:flex;position:relative;"]);
export { Wrapper, InnerWrapper };